<template>
  <v-app>
    <v-app-bar
        v-if="$store.state.user!=null" app dark color="transparent"
        :extension-height="tabsShow ? 48 : 0"
    >
      <back v-if="$store.state.user!==null" :height="64+(tabsShow ? 48 : 0)"/>
      <portal-target v-show="backShow" name="back" style="background-color:transparent" @change="backChange"/>
      <v-toolbar-title>
        <portal-target v-show="titleShow" name="title" style="background-color:transparent" @change="titleChange"/>
        <div v-if="!titleShow">{{$router.currentRoute.meta.title}}</div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <call-group-widget ref="callerGroupWidget"/>
      <notifs/>
      <user-bar/>
      <template v-slot:extension>
        <portal-target name="tabs" class="full-width d-inline-block" style="background-color:transparent" @change="tabsChange"/>
      </template>
    </v-app-bar>
    <v-navigation-drawer v-if="$store.state.user!=null" app :mini-variant="menuIsMini" permanent>
      <back :height="64"/>
      <v-toolbar class="logo-toolbar" dark color="transparent">
        <v-sheet min-width="220" class="overflow-hidden" color="transparent">
          <v-row no-gutters>
            <v-col cols="auto" align-self="center">
              <logo/>
            </v-col>
            <v-col v-if="!menuIsMini" class="text--white ml-4">
                <div class="body-1 font-weight-medium">Mediana</div>
                <div class="caption mt-n1">UI: {{versionText}}</div>
            </v-col>
          </v-row>
        </v-sheet>
      </v-toolbar>
      <v-sheet style="height:calc(100% - 64px)">
        <v-sheet height="100" class="overflow-y-auto overflow-x-hidden fill-height" style="height:calc(100% - 56px)">
          <v-list class="pa-0" dense>
            <v-list-item v-for="item in menu.filter(v=>v.show)" :key="item.title" :to="item.to" link>
              <v-list-item-icon class="mr-4 py-4">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-sheet>
        <v-list class="pa-0">
          <v-list-item @click="menuIsMini=!menuIsMini">
            <v-list-item-icon>
              <v-icon v-if="menuIsMini">mdi-arrow-right-drop-circle-outline</v-icon>
              <v-icon v-else>mdi-arrow-left-drop-circle-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium text--secondary">Свернуть меню</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-sheet>
    </v-navigation-drawer>
    <v-main v-if="$store.state.user!=null">
      <router-view/>
    </v-main>

    <login v-if="$store.state.user==null"/>

    <v-snackbars
        :objects.sync="$store.state.page.snackbars"
        class="overflow-hidden"
    >
      <template v-slot:default="{ message }">
        <div v-html="$tools.nl2br(message)" class="d-inline-block"></div>
      </template>
      <template v-slot:action="{ close, index }">
        <btn-close-timed
            @click="close()"
            color="white"
            :time="$store.state.page.snackbars[index].timeout"
            :loading="$store.state.page.snackbars[index].loading"
            :size="34"
        >
          <v-icon size="20">mdi-close</v-icon>
        </btn-close-timed>
      </template>
    </v-snackbars>
    <v-snackbar v-model="wsConnectConnecting" :timeout="100000" bottom right color="red">
      <v-row no-gutters>
        <v-col class="mr-2">Соединение разорвано. Попытка переподключения...</v-col>
        <v-col cols="auto" class="mr-n2">
          <v-progress-circular indeterminate size="22" width="3"/>
        </v-col>
      </v-row>
    </v-snackbar>
  </v-app>
</template>


<script>
import VSnackbars from "v-snackbars";
import Login from "@/views/User/Login.vue";
import axios from "axios";
import Promise from "q";
import UserBar from "@/views/User/components/UserBar.vue";
import CallGroupWidget from "@/views/ContactCenter/Call/CallGroupWidget.vue";
import BtnCloseTimed from "@/componentsV2/base/BtnCloseTimed.vue";
import Notifs from "@/views/User/components/Notifs.vue";
import Back from "@/componentsV2/base/Back.vue";
import Logo from "@/componentsV2/base/Logo.vue";

export default {
  components:{
    Logo,
    Back,
    Notifs,
    BtnCloseTimed,
    CallGroupWidget, UserBar, "v-snackbars": VSnackbars, Login},
  data: () => ({
    menu: [
      { title: 'Рабочий стол', perm:'visits', show:true, icon: 'mdi-monitor', to:'/desktop/' },
      { title: 'Пользователи', perm:'users', show:true, icon: 'mdi-account-multiple-outline', to:'/user/' },
      { title: 'Визиты', perm:'visits', show:true, icon: 'mdi-calendar-today', to:'/visit/' },
      { title: 'Планы работы спец.', perm:'userSpecPlans', show:true, icon: 'mdi-calendar-account', to:'/userSpecPlans/' },
      { title: 'Прайс лист', perm:'services', show:true, icon: 'mdi-currency-rub', to:'/price/' },
      { title: 'Оказанные услуги', perm:'servicesRendered', show:true, icon: 'mdi-clipboard-text-search-outline', to:'/visitService/' },
      { title: 'Планы лечения', perm:'medplans', show:true, icon: 'mdi-clipboard-list-outline', to:'/medPlan/' },
      { title: 'Мед. записи', perm:'medrecords', show:true, icon: 'mdi-clipboard-text-multiple-outline', to:'/medRecord/' },
      //{ title: 'Анализы', perm:'servicesRendered', show:true, icon: 'mdi-clipboard-pulse-outline', to:'/labRequest/' },
      { title: 'Документы', perm:'docs', show:true, icon: 'mdi-file-document-multiple-outline', to:'/document/' },
      { title: 'Финансы', perm:'finances', show:true, icon: 'mdi-cash-multiple', to:'/financeOld/' },
      { title: 'Аналитика', perm:'analytics', show:true, icon: 'mdi-chart-timeline-variant', to:'/analytic/' },
      { title: 'Контакт-центр', perm:'contactCenter', show:true, icon: 'mdi-phone-message', to:'/contactCenter/' },
      //{ title: 'Финансы (тестирование)', perm:'finances', show:true, icon: 'mdi-circle', to:'/finance/' },
      { title: 'Настройки', perm:'settings', show:true, icon: 'mdi-cog-outline', to:'/settings/' },
      //{ title: 'Организации', icon: 'mdi-office-building' },
      //{ title: 'Оплата', icon: 'mdi-currency-usd' },
      //{ title: 'Документы', icon: 'mdi-file-document' },
    ],
    menuIsMini: true,
    meta: null,
    title: null,
    titleShow: false,
    backShow: false,
    tabsShow: false,
    visible:true,
    subscribeListenerId:null,
    wsConnectInterval:null,
    wsConnectConnecting:false,
  }),
  mounted() {
    this.$tools.pageVisibleInit();
    document.onvisibilitychange = () => {
      this.visible = document.visibilityState==='visible';
    };

    axios.interceptors.response.use(null, (error)=> {
      if (error.config?.skipGlobalError) {
        return Promise.reject(error);
      }

      const statusCode = error.response ? error.response.status : null;
      if (statusCode===403) {
        this.$tools.debounce(()=>{
          this.$store.commit('alertError', 'Авторизация истекла. Необходима повторная авторизация');
          this.$store.state.user = null;
        });
      } else if (statusCode>=400 && statusCode<=500) {
        this.$tools.debounce(()=>{
          this.$store.commit('alertWarning', error.response.data.message);
        });
      } else if (statusCode>=500) {
        this.$tools.debounce(() => {
          this.$store.commit('alertError', 'Ошибка в работе МИС. Если ошибка повторяется свяжитесь с тех. подержкой');
        });
      }
      return Promise.reject(error);
    })
    if(this.$store.state.user!==null && this.visible)
      this.$ws.connect(this.$store.state.user);

    if(typeof localStorage.versionUI==='undefined' || localStorage.versionUI!==process.env.VUE_APP_VERSION){
      let v = process.env.VUE_APP_VERSION.split('.')[2];
      this.$store.commit('alertSuccess', 'Интерфейс Mediana обновлен. Версия от '+v.substring(6,8)+'.'+v.substring(4,6)+'.'+v.substring(0,4));
      localStorage.versionUI = process.env.VUE_APP_VERSION;
    }
  },
  beforeDestroy() {
    this.$ws.removeSubscribeListener(this.subscribeListenerId);
    if(this.wsConnectInterval)
      clearInterval(this.wsConnectInterval)
  },
  watch: {
    '$store.state.user'() {
      if(!this.$tools.isEmpty(this.$store.state.user?.perms)){
        this.menu.forEach(v=>{
          v.show = this.$permsCheck(v.perm, false, ()=>this.$store.state.user?.perms.includes(v.perm));// если найдено хоть одно совпадение
        });
      } else {
        this.menu.forEach((v)=>{
          v.show = false;
        });
      }

      if(this.$store.state.user===null || this.$store.state.user.id===null) {
        this.$ws.removeSubscribeListener(this.subscribeListenerId);
        this.$ws.disconnect();
        if(this.wsConnectInterval)
          clearInterval(this.wsConnectInterval)
      } else {
        this.$ws.connectWithSubscribeListener(
          this.$store.state.user,
          (v)=> {
            this.subscribeListenerId = v
          },
          (m)=>{
            if(m.type==='notif')
              this.$store.commit('alertSuccess', m.data.text)
            if(m.type==='callUpdate')
              this.$refs.callerGroupWidget.event(m.data);
          }
        );
        this.wsConnectInterval = setInterval(()=> {
          if(this.wsConnectConnecting && this.$ws.client.state==='connected')
            this.$store.commit('alertSuccess', 'Соединение восстановлено')
          this.wsConnectConnecting = this.$ws.client.state === 'connecting'
        }, 1000)
      }
    },
  },
  computed: {
    versionText() {
      return process.env.VUE_APP_VERSION;
    }
  },
  methods:{
    titleChange(v){ this.titleShow = v },
    backChange(v){ this.backShow = v },
    tabsChange(v){ this.tabsShow = v },
  }
};
</script>

<style lang="scss" >
  .logo-toolbar {
    .v-toolbar__content {
      padding: 4px 8px;
    }
  }
</style>